import Sidebar from "./sidebar";

const MoviesListAdmin = () => {
  // Películas hardcodeadas con más detalles
  const movies = [
    {
      id: 1,
      title: "El Padrino",
      director: "Francis Ford Coppola",
      year: 1972,
      genre: "Drama/Crimen",
  
    },
    {
      id: 2,
      title: "Pulp Fiction",
      director: "Quentin Tarantino",
      year: 1994,
      genre: "Crimen/Drama",
  
    },
    {
      id: 3,
      title: "El Caballero Oscuro",
      director: "Christopher Nolan",
      year: 2008,
      genre: "Acción/Drama",
    
    },
    {
      id: 4,
      title: "Parásitos",
      director: "Bong Joon-ho",
      year: 2019,
      genre: "Drama/Thriller",
     
    },
    {
      id: 5,
      title: "Interestelar",
      director: "Christopher Nolan",
      year: 2014,
      genre: "Ciencia ficción",

    }
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar fijo */}
      <div className="fixed h-full w-64">
        <Sidebar />
      </div>
      
      {/* Contenido principal con margen */}
      <div className="ml-64 flex-1 overflow-y-auto p-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">Listado de Películas</h1>
          
          {/* Tabla de películas */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Título</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Director</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Año</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Género</th>
                 
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {movies.map(movie => (
                  <tr key={movie.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{movie.title}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{movie.director}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{movie.year}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{movie.genre}</td>
                   
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoviesListAdmin;